import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';

@Injectable({
  providedIn: 'root'
})
export class SystemConfigurationService {

  constructor(private httpService : HttpService) { }

  fetchBusinessRules(){
    return this.httpService.get(API_ENDPOINTS.BUSINESS_RULES);
  }
  insertBusinessRule(data: any){
    return this.httpService.post(API_ENDPOINTS.INSERT_BUSINESS_RULE, data);
  }
  updateBusinessRule(data: any){
    return this.httpService.patch(API_ENDPOINTS.UPDATE_BUSINESS_RULE, data);
   }
   getTemplateNames(){
    return this.httpService.get(API_ENDPOINTS.DATA_TEMPLATES.GETPORTAL_NAMES+ '/DAT');
  }
  getTemplateColumns(value:number){
    return this.httpService.get(API_ENDPOINTS.DATA_TEMPLATES.GETTEMPLATE_COLUMNS + '/'+ value);
  }
   getTemplateDataBycolTempId(value:number,value1 : number){
    return this.httpService.get(API_ENDPOINTS.DATA_TEMPLATES.GETTEMPLATE_COLUMNS + '/'+ value + '/'+ value1);
  }
  saveTemplateColumns(data: any){
    return this.httpService.post(API_ENDPOINTS.DATA_TEMPLATES.SAVE_TEMPLATE_COLUMNS, data);
  }
  updateTemplateColumns(data: any,value : number){
    return this.httpService.put(API_ENDPOINTS.DATA_TEMPLATES.UPDATE_TEMPLATE_COLUMNS + '/'+ value , data);
  }
  deactivateLeaTemplate(data: any){
    return this.httpService.post(API_ENDPOINTS.DATA_TEMPLATES.DEACTIVATE_LEA_TEMPLATE, data);
  }
  deactivateEppTemplate(data: any){
    return this.httpService.post(API_ENDPOINTS.DATA_TEMPLATES.DEACTIVATE_EPP_TEMPLATE, data);
  }
  getToastMessages(){
    return this.httpService.get(API_ENDPOINTS.TOAST_MESSAGES);
  }
  getErrorMessages(){
    return this.httpService.get(API_ENDPOINTS.MESSAGES);
  }
  getContentManagementData(){
   return this.httpService.get(API_ENDPOINTS.CONTENT_MANAGEMENT.GET_CONTENT);
  }
  getContentByKey(key: string){
    return this.httpService.get(`${API_ENDPOINTS.CONTENT_MANAGEMENT.GET_CONTENT_BY_KEY}/${key}`);
  }
  saveContentManagementData(data: { key: string; value: string; content: string }){
    return this.httpService.put(API_ENDPOINTS.CONTENT_MANAGEMENT.SAVE_CONTENT, data);
  }
}
